import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./ShippingAddressModal.module.scss";

import ModalBottomFlexible2 from "../ModalBottomFlexible2";

import { uploadSelectionActions } from "../../../actions/uploadSelection";

import UploadJourney from "../UploadJourney";
import { monthNamesV2 } from "../../../static/data/dataForForms";
import UploadShippingModal from "./UploadShippingModal";

import { getAddresses } from "../../../api";

export default ({ onClose, isOpened,onUpdateAddresses }) => {
 
  return (
    isOpened && (
      <div className={styles.SwitchProfile}>
        <ModalBottomFlexible2
          isOpen
          onClose={() => {
            onClose();
          }}
        >
          <UploadShippingModal
            onClose={() => onClose()}
            onUpdateAddresses={onUpdateAddresses}
          />
        </ModalBottomFlexible2>
      </div>
    )
  );
};
